import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { CalidadModule } from '../modelo/calidad/calidad.module';

@Injectable({
  providedIn: 'root'
})
export class CalidadService {

  constructor(private http: HttpClient) { }

  registrar(calidad :CalidadModule[])
  {

    return this.http.put(environment.apiUrl+"actulizarCalidad/",calidad); 
   }


   listarCalidad(fecha: string )
   {
 
     return this.http.get(environment.apiUrl+"listarCalidad/"+fecha); 
    }
 
}
